import type { CommonStore } from './interfaces'

export const actions = {
  setLoading (this: CommonStore, payload: CommonStore['loading']): void {
    this.loading = payload
  },
}
